
export class ProjectsReportDto {
    monthWiseId?: number;
    empId: number;
    year: number;
    month: number;
    // empCode: string;
  subContractorId: number;
    costcenterId: number;
    projectId: number
    status: boolean;
    // createdAt : Date | any;
    // createdUser : number;
    // updatedAt : Date | any;
    // updatedUser : number;
    // versionFlag : number;
}

export const ProjectsReportDtoDefault : ProjectsReportDto = {
    monthWiseId: 1,
    empId: 0,
    // empCode: "",
  subContractorId:0,
    costcenterId: 0,
    projectId: 0,
    year: 0,
    month: 0,
    status: true,
    // createdAt : new Date() ,
    // createdUser : 0,
    // updatedAt : new Date() ,
    // updatedUser : 0,
    // versionFlag : 1

};

